'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'ranking-star';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e561';
var svgPathData = ['M64 368l0 96 96 0 0-96-96 0zm144-64l0 160 96 0 0-160-96 0zm144 96l0 64 80 0 0-64-80 0z', 'M308.9 256.3c24.2 2.5 43.1 22.9 43.1 47.8l0 48 80 0 4.9 .2c24.2 2.5 43.1 22.9 43.1 47.8l0 64-.2 4.9c-2.3 22.6-20.3 40.6-42.8 42.8l-4.9 .2-368 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l96 0 0-16c0-24.9 18.9-45.3 43.1-47.8l4.9-.2 96 0 4.9 .2zM64 464l96 0 0-96-96 0 0 96zm144 0l96 0 0-160-96 0 0 160zm144 0l80 0 0-64-80 0 0 64zM245.8 6.3c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8 52.3 7.5c9.3 1.4 13.2 13 6.4 19.8l-37.9 36.6 8.9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.5-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l8.9-52.1-37.9-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5 23.6-47.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRankingStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;